/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type ClassroomRoleResRole =
  (typeof ClassroomRoleResRole)[keyof typeof ClassroomRoleResRole];

export const ClassroomRoleResRole = {
  OWNER: 'OWNER',
  MEMBER: 'MEMBER',
  NONE: 'NONE',
} as const;
